'use client';
import dynamic from 'next/dynamic';

import { BlogListing } from '@/services/blog/BlogService';

const NewsFeed = dynamic(() => import('../NewsFeed'), { ssr: false });

const NewsFeedDynamic = ({ dealerBlogs }: { dealerBlogs: BlogListing[] }) => {
  return <NewsFeed dealerBlogs={dealerBlogs} />;
};

export default NewsFeedDynamic;
